var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCardEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.5c.41 0 .75.34.75.75s-.34.75-.75.75H2zM6 17.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H6zM10.5 17.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44 21.25c-3.98 0-5.19-1.2-5.19-5.14V7.89c0-3.94 1.21-5.14 5.19-5.14h8.06c.41 0 .75.34.75.75s-.34.75-.75.75H6.44c-3.14 0-3.69.54-3.69 3.64v8.21c0 3.1.55 3.64 3.69 3.64h11.11c3.14 0 3.69-.54 3.69-3.64v-4.08c0-.41.34-.75.75-.75s.75.34.75.75v4.08c.01 3.95-1.2 5.15-5.18 5.15H6.44z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.03c-.32-.32-.46-.78-.39-1.26l.2-1.42c.05-.36.27-.79.52-1.04l3.71-3.71c1.47-1.47 2.75-.63 3.39 0 .63.63 1.47 1.91 0 3.39l-3.71 3.71c-.26.26-.69.47-1.04.52l-1.42.2c-.08.01-.16.02-.24.02-.39 0-.76-.14-1.02-.41zm5.1-6.37-3.7 3.71a.75.75 0 0 0-.1.2l-.2 1.35 1.36-.19a.75.75 0 0 0 .2-.1l3.71-3.71c.47-.47.54-.73 0-1.26-.26-.26-.45-.38-.64-.38-.2 0-.38.14-.63.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.67 7.71a4.121 4.121 0 0 1-2.84-2.84.76.76 0 0 1 .52-.93c.4-.11.81.12.93.52.25.87.94 1.56 1.81 1.81.4.11.63.53.52.92a.79.79 0 0 1-.74.55c-.07 0-.14-.01-.2-.03z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCardEdit);
export default __webpack_public_path__ + "static/media/vuesax-outline-card-edit.cc4f12c80aeb4f0ea94f9ff061b3e4c0.svg";
export { ForwardRef as ReactComponent };